// Empty /categories/:id visits should land on the crawlable set URL.
// Shopping query strings stay on the browse page.
// loadedTagId must match the category in the URL. The previous tag stays
// mounted while the next category request is in flight.
const categorySetLandingRedirect = (
  search: string,
  landingPath?: string | null,
  loadedTagId?: number,
  requestedTagId?: number,
): string | undefined => {
  if (requestedTagId !== undefined && loadedTagId !== requestedTagId) return undefined
  if (!landingPath) return undefined

  const query = search.startsWith('?') ? search.slice(1) : search
  if (query.length > 0) return undefined

  return landingPath
}

// categoriesLink always appends view=listings. That default is not a shopping
// filter. Rarity, price, search, stocks, and a non-default view stay on the
// browse URL the tile would have used.
const SHOPPING_FILTER_KEYS = [
  'query',
  'q',
  'rarities',
  'min_price',
  'max_price',
  'card_types',
  'energy_types',
  'conditions',
  'stocks',
  'sort',
  'page',
  'user_id',
  'game',
]

const browseHrefHasShoppingFilters = (href: string): boolean => {
  const query = href.includes('?') ? href.slice(href.indexOf('?') + 1) : ''
  if (!query) return false

  const params = new URLSearchParams(query)
  if (SHOPPING_FILTER_KEYS.some((key) => params.get(key))) return true

  const view = params.get('view')
  return view !== null && view !== '' && view !== 'listings'
}

const setTileHref = (browseHref: string, landingPath?: string | null): string => {
  if (landingPath && !browseHrefHasShoppingFilters(browseHref)) return landingPath
  return browseHref
}

export { browseHrefHasShoppingFilters, categorySetLandingRedirect, setTileHref }
